<script setup lang="ts">
import {ref, unref, computed} from "vue";
import {ClickOutside as vClickOutside} from 'element-plus'
import Menu from "components/Menu.vue";
import {useRouter} from "vue-router";
import {userUserStore} from "@/store/user.ts";
import {SwitchButton} from "@element-plus/icons-vue";

const userStore = userUserStore();
const router = useRouter();

const username = computed(() => userStore.name)

const buttonRef = ref()
const popoverRef = ref()
const onClickOutside = () => {
  unref(popoverRef).popperRef?.delayHide?.()
}

const onQuitLogin = () => {
  userStore.reset()
  router.push({path: "/"})
}
</script>

<template>
  <el-container class="h-100vh flex flex-col">
    <el-header class="my-header">
      <div id="header-content" class="flex items-center position-relative shadow-md px-20px">
        <div class="text-1.2em font-bold">创作服务中心</div>
        <div id="user-info" class="absolute right-1.75rem flex items-center">
          <el-icon class="cursor-pointer" ref="buttonRef" v-click-outside="onClickOutside"><SwitchButton /></el-icon>
          <el-popover
              ref="popoverRef"
              :virtual-ref="buttonRef"
              trigger="click"
              title=""
              virtual-triggering
          >
            <span class="cursor-pointer" @click="onQuitLogin">退出登录</span>
          </el-popover>
          <span class="ml-.75rem">{{ username }}</span>
        </div>
      </div>
    </el-header>
    <el-container class="flex-1">
      <el-aside width="12.5rem" class="my-aside">
        <Menu class="w-full h-full"></Menu>
      </el-aside>
      <el-main class="my-main bg-#f5f5f5">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<style scoped>
.my-header {
  --el-header-height: 4rem;
  --el-header-padding: 0 0px;
}

.my-aside {
  height: calc(100vh - 4rem);
}

.my-main {
  padding: 0;
  height: calc(100vh - 4rem);
}

#header-content {
  margin: auto;
  height: 100%;
}
</style>